import React from 'react';
import { Card as AntCard, Alert } from '../';
import { MoreOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import './RMCard.scss';

/**
 * Base RMCard Component
 *
 * A themed wrapper around AntCard that provides the styling shared by every
 * dashboard card, including a consistent card styling, the optional "..."
 * more-actions icon, and a card-level error state.
 *
 * RMCard is a layout primitive that card components wrap around their own content,
 * passed in as `children`. Those components own their data/props and decide
 * what to render, RMCard only owns the surrounding styled container and the isError
 * overlay/disabled-more-icon behavior.
 */
export const RMCard = ({ children, className = '', showMoreIcon = true, onMoreClick, isError = false, ...props }) => {
    const containerClass = classNames('rm-card-container', { 'rm-card-container--error': isError });

    return (
        <AntCard className={classNames('rm-card', className)} {...props}>
            <div className={containerClass}>
                <div className="rm-card-content">{children}</div>
                {showMoreIcon && (
                    <MoreOutlined
                        className={classNames('rm-card-more-icon', { 'rm-card-more-icon--disabled': isError })}
                        onClick={isError ? undefined : onMoreClick}
                    />
                )}
            </div>
            {isError && (
                <div className="rm-card-error-overlay">
                    <Alert type="error" title="Error loading data" showIcon icon={<ExclamationCircleOutlined />} />
                </div>
            )}
        </AntCard>
    );
};
